/**
 * Returns the env to ping config url
 */
function getEnvAndClient() {
  const host = location.host;
  const urlParts = host.split('.');
  const isDev = window.location.href.indexOf('localhost');
  // const env = (isDev > 0 ? 'development' : 'dev');
  const env = 'dev';
  const client = (isDev > 0 ? 'devuser' : urlParts[0]);
  return { env, client };
}

/**
 * Returns the firebase config w.r.t client
 * @param {string} client - On which client url is the user on
 */
function getConfig() {
  const { env, client } = getEnvAndClient();
  const config = JSON.parse(localStorage.getItem(env));
  const clientConfig = JSON.parse(localStorage.getItem(client));
  return { config, env, client, clientConfig };
}

/**
 * Saves the firebase config w.r.t client
 * @param {string} client - On which client url is the user on
 */
function saveConfig(env, config) {
  localStorage.setItem(env, JSON.stringify(config));
}

/**
 * Clears the firebase config w.r.t client
 * @param {string} client - On which client url is the user on
 */
function clearConfig(env) {
  localStorage.removeItem(env);
  localStorage.removeItem('firebase_email_id');
  if (localStorage.getItem('is_anonymous_login')) localStorage.removeItem('is_anonymous_login');
}

/**
 * Normalizes the config object to firebase config object required to initialise
 * @param {string} config - Config fetched from aws
 * @return {object} webConfig - Config used to initialise firebase
 */
function normalizeConfig(config) {
  const companyConfig = config.company_configuration;
  const webConfig = companyConfig && companyConfig.web;
  return webConfig;
}

export {
  getConfig,
  saveConfig,
  clearConfig,
  normalizeConfig,
};



// WEBPACK FOOTER //
// ./src/helpers/config.js